/* @flow */
import {
  SET_VIEW_PANEL,
  SET_SEARCH_TERM,
  SET_SEARCH_OPTIONS,
  TRIGGER_SEARCH,
  EXECUTE_SEARCH,
  FETCH_IOCS,
  FETCH_REPORTS,
  UPDATE_REPORT_PAGE_FILTERS,
  CLEAR_REPORT_SEARCH_FILTERS,
  UPDATE_ENTITY_PAGE_FILTERS,
  CLEAR_ENTITY_SEARCH_FILTERS,
  EXECUTE_ENTITIES_SEARCH,
  UPDATE_SEARCH_PAGE_FILTERS,
  CLEAR_SEARCH_PAGE_FILTERS,
  EXECUTE_REPORTS_SEARCH,
} from './action-types.js';

import { reset as resetForm } from 'redux-form/immutable';
import {type viewPanelType} from './types';

/* Reset search form */
export const resetSearch = () => resetForm('search');

/**
 * NOTE: It's important to default to an empty string b/c if we pass undefined
 * in the dispatch the store will throw an error, saying an actual value must be
 * returned.
 */
export const setSearchTerm = (search: string = '') => ({
  type: SET_SEARCH_TERM,
  payload: search
});

export const setSearchOptions = (options: Object) => ({
  type: SET_SEARCH_OPTIONS,
  payload: options,
});

/* Trigger a search: url path will be udpated */
export const triggerSearch = (search: string = '') => ({
  type: TRIGGER_SEARCH,
  payload: search
});

/* Search for IOCs directly, accepts searchDto parameters.
 * Used for pagination of IOC results. */
export const fetchIOCs = (searchDto: Object) => ({
  type: FETCH_IOCS,
  payload: searchDto
});

/* Search for Reports directly, accepts searchDto parameters.
 * Used for pagination of Report results. */
export const fetchReports = (searchDto: Object) => ({
  type: FETCH_REPORTS,
  payload: searchDto
});

// Search 2.0
export const updateReportFilters = (payload: Object, fields?: Array<string>, dispatchSearchAfterUpdate?: boolean) => ({
  type: UPDATE_REPORT_PAGE_FILTERS,
  payload,
  fields,
  dispatchSearchAfterUpdate,
});

// Resets report query payload to its default state
export const clearReportFilters = (dispatchSearchAfterUpdate?: boolean) => ({
  type: CLEAR_REPORT_SEARCH_FILTERS,
  dispatchSearchAfterUpdate,
});

export const executeReportQuery = (payload: Map<string, any>) => ({
  type: EXECUTE_REPORTS_SEARCH,
  payload
});

export const updateEntityFilters = (payload: Object, fields?: Array<string>, dispatchSearchAfterUpdate?: boolean) => ({
  type: UPDATE_ENTITY_PAGE_FILTERS,
  payload,
  fields,
  dispatchSearchAfterUpdate,
});

// Resets entity query payload to its default state
export const clearEntityFilters = (dispatchSearchAfterUpdate?: boolean) => ({
  type: CLEAR_ENTITY_SEARCH_FILTERS,
  dispatchSearchAfterUpdate,
});

export const executeEntityQuery = (payload: Map<string, any>) => ({
  type: EXECUTE_ENTITIES_SEARCH,
  payload
});

/* Sets view panel for search results: ALL | ENTITIES | REPORTS */
export const setViewPanel = (panel: viewPanelType) => ({
  type: SET_VIEW_PANEL,
  payload: panel
});

/* This will trigger a global search: i.e. IOCs and reports will be fetched */
export const executeSearch = (search: string) => ({
  type: EXECUTE_SEARCH,
  payload: search
});

export const updateSearchPageFilters = (payload: Object, fields?: Array<string>, dispatchSearchAfterUpdate?: boolean) => ({
  type: UPDATE_SEARCH_PAGE_FILTERS,
  payload,
  fields,
  dispatchSearchAfterUpdate,
});

export const clearSearchPageFilters = (dispatchSearchAfterUpdate?: boolean) => ({
  type: CLEAR_SEARCH_PAGE_FILTERS,
  dispatchSearchAfterUpdate,
});



// WEBPACK FOOTER //
// ./src/app/modules/search/actions.js